<app-doc-viewer
  title="Import / Export"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/import-export">
    <mat-grid-list cols="2" rowHeight="500px" gutterSize="16px">
      <mat-grid-tile>
        <igo-map-browser [map]="map" [view]="view">
          <div class="map-actions --vertical --bottom --right">
            <igo-zoom-button [map]="map" color="primary" />
          </div>
        </igo-map-browser>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="flex align-start h-100 w-100">
          <igo-import-export class="w-100" [store]="store" [map]="map" />
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </app-example-viewer>
</app-doc-viewer>
